module.exports = __webpack_public_path__ + "img/orange1.9628511d.jpg";